<template>
  <div class="history-panel">
    <div class="history-title">新闻与传播研究所机构历史沿革</div>

    <div class="history-meta">
      <span>1978—2018</span>
      <span>按年份顺序整理</span>
    </div>

    <section
      v-for="entry in timeline"
      :key="entry.year"
      class="history-section"
    >
      <div class="history-year">{{ entry.year }}</div>
      <div class="history-body">
        <p
          v-for="paragraph in entry.events"
          :key="`${entry.year}-${paragraph}`"
        >
          {{ paragraph }}
        </p>
      </div>
    </section>

    <p class="history-note">（所党办根据档案整理）</p>
  </div>
</template>

<script>
export default {
  name: 'InstitutionHistoryContent',
  data() {
    return {
      timeline: [
        {
          year: '一九七八年',
          events: [
            '6 月，经中国社会科学院（78）办字 9 号文件请示及邓小平、李先念等同志批复同意，成立新闻研究所。'
          ]
        },
        {
          year: '一九七九年',
          events: [
            '5 月，社科院政治部发文，同意安岗、温济泽、翟向东、李普、罗列、戴邦、谭立、谢冰岩、赵一鹤组成新闻所第一届学术委员会。学术委员会选举安岗为主任委员，戴邦为副主任委员。',
            '8 月，由安岗、戴邦、谭立、谢冰岩、张铁、王敬、师于七同志组成新闻所党委会，戴邦任书记，谭立、张铁任副书记。'
          ]
        },
        {
          year: '一九八零年',
          events: [
            '5 月，新闻所机构设置为：报刊室、党报室、世界新闻室、新闻理论室、新闻业务室、摄影室、编辑部、图资室、办公室、新闻学会。',
            '10 月，戴邦任新闻所党委书记（兼）。'
          ]
        },
        {
          year: '一九八一年',
          events: [
            '10 月，新闻所党委向院人事局备案的各室负责人为：新闻理论室主任：钱辛波；中国新闻业史研究室主任：方蒙；副主任：阎希同；党的新闻业史研究室主任：方德；副主任：王敬、李连斌；世界新闻业史研究室副主任：陶涵、张黎；图书资料室主任：刘克良；新闻摄影研究室主任：高粮（人民日报干部兼职）；电视、广播研究室筹备负责人：姜宇辉；编辑出版组组长：钱辛波（兼）；副组长：何光先。'
          ]
        },
        {
          year: '一九八二年',
          events: [
            '7 月，新闻所人员和机构情况：名誉所长：石西民；所长：安岗；副所长：戴邦、钱辛波；顾问：谢冰岩；党组书记：戴邦，党组成员：张铁、钱辛波、杨润时、裴达。',
            '下设七个室：新闻理论研究室（副主任：卢惠民）；中国报刊业史研究室（主任：王敬；副主任：王凤超）；世界新闻业研究室（主任：张黎；副主任：徐耀魁）；电视广播研究室（主任：姜宇辉）；编辑室（主任：何光先；副主任：张钰）；图书资料室（主任：刘克良；副主任：金耀云）；科研组织处（处长：杨润时）；行政办公室（副主任：邓济民、李桂山）。',
            '10 月，社科院机关党委同意张铁、师于、阎希同、王凤超、李桂山组成新闻所机关党委会，张铁任书记，师于任副书记。',
            '11 月，社科院党组任命戴邦为新闻所分党组书记，钱辛波、张铁、杨润时、裴达为分党组成员。',
            '12 月，社科院同意由李普、丁济沧、关在汉、余致浚、石西民、安岗、戴邦、钱辛波、谢冰岩、方蒙、王敬、何光先、裴达组成新闻所第二届学术委员会。'
          ]
        },
        {
          year: '一九八三年',
          events: [
            '5 月，王凤超任新闻所机关党委副书记。',
            '11 月，杨润时任新闻所副所长。'
          ]
        },
        {
          year: '一九八四年',
          events: [
            '1 月，社科院任命商恺为新闻所所长。',
            '4 月，东生任新闻所副所长。',
            '8 月，社科院机关党委同意王凤超担任新闻所机关党委书记。'
          ]
        },
        {
          year: '一九八五年',
          events: [
            '6 月，社科院任命石西民为新闻所名誉所长，商恺为所长。',
            '7 月，社科院任命东生、王凤超、孙旭培为新闻所副所长。',
            '8 月，新闻所向院人事局备案的处室干部名单：岳颂东为报刊研究室副主任；夏晓林为报刊研究室副主任；徐耀魁为世界新闻研究室主任；何光先为新闻业务研究室主任；彭朝丞为新闻业务研究室副主任；金耀云为图书资料室副主任；李桂山为图书资料室副主任；郑书奇为行政办公室主任；邹本浩为行政办公室副主任；赫建中为行政办公室副主任；陈力丹为新闻理论研究室副主任；卢惠民为新闻理论研究室副主任；窦其文为出版社副社长（正处待遇）；邓济民为副处调研员。'
          ]
        },
        {
          year: '一九八六年',
          events: [
            '4 月，社科院党组任命商恺为新闻所分党组书记；东生、王凤超、孙旭培、郑书奇为分党组成员。'
          ]
        },
        {
          year: '一九八七年',
          events: [
            '4 月，社科院机关党委同意刘宁波、韩淦如为新闻所机关党委委员。',
            '10 月，新闻所向院人事局备案处室干部：闵大洪为办公室副主任；明安香为世界新闻研究室副主任。'
          ]
        },
        {
          year: '一九八八年',
          events: [
            '5 月，社科院任命孙旭培为新闻所副所长（代理所长工作）；王凤超、卫景福为副所长。免去商恺所长职务。',
            '8 月，社科院机关党委同意卫景福、郑书奇、宁新、闵大洪、韩淦如、刘宁波、王九刚组成新闻所机关党委会，卫景福任书记，郑书奇任副书记。',
            '10 月，院人事教育局文件批复同意增设传播研究室。'
          ]
        },
        {
          year: '一九八九年',
          events: [
            '1 月，社科院任命孙旭培为新闻所所长，徐耀魁为副所长；免去王凤超副所长职务。',
            '12 月，社科院批复由孙旭培、徐耀魁、杨友吾、商恺、王敬、何炳然、方汉奇组成临时学术委员会。孙旭培任主任委员，徐耀魁任副主任委员。'
          ]
        },
        {
          year: '一九九一年',
          events: [
            '2 月，社科院同意由孙旭培、徐耀魁、商恺、王敬、何炳然、方汉奇组成新闻所临时学术委员会，孙旭培任主任委员，徐耀魁任副主任委员。',
            '6 月，社科院处室机构核查后，新闻所处室机构为：马列主义、毛泽东思想新闻理论研究室、新闻业务研究室、新闻事业史研究室、传播研究室、世界新闻研究室、图书资料室、办公室。',
            '7 月，社科院任命：郑书奇为办公室主任；李桂山为办公室副主任；李斯颐为办公室副主任；陈力丹为新闻理论室主任；徐耀魁为编辑室主任（兼）；明安香为世界新闻与传播研究室主任；阎焕书为编辑室副主任；夏晓林为编辑室副主任；彭朝丞为新闻业务室副主任；金耀云为资料室主任；闵大洪为报刊史室副主任；孟孝礼为三级调研员；邹本浩为三级调研员；免去：李桂山资料室副主任职务；闵大洪办公室副主任职务；徐耀魁世界新闻室主任职务；明安香传播研究室主任职务；夏晓林报刊史室副主任职务；孟孝礼办公室副主任职务。',
            '8 月，社科院批复同意新闻所成立编辑室，同时将世界新闻室和传播室合并为世界新闻与传播研究室。',
            '12 月，任命郑书奇为新闻所一级调研员。'
          ]
        },
        {
          year: '一九九二年',
          events: [
            '10 月，社科院批复同意新闻所研究系列中级专业职务评委会由孙旭培、徐耀魁、方汉奇、沈如钢、柏生、何炳然、王敬、王美芝、商恺、宁新、陈崇山、闵大洪、彭朝丞、陈力丹、明安香 15 人组成。',
            '10 月，社科院任命：马桂芝为办公室副主任；孙京华为办公室副主任；朱向霞为图书资料室副主任。'
          ]
        },
        {
          year: '一九九三年',
          events: [
            '4 月，新闻出版署期刊司批复同意新闻所《新闻研究资料》更名为《新闻与传播研究》。'
          ]
        },
        {
          year: '一九九四年',
          events: [
            '2 月，社科院党委任命张秉意为新闻研究所党委书记。社科院任命张秉意为新闻所副所长。',
            '5 月，社科院党委决定，新闻所实行党委领导下的所长负责制，新党委暂由三位同志组成：书记张秉意，委员孙旭培、宁新。',
            '7 月，社科院任命喻权域为新闻所所长（兼），孙旭培为副所长（正局级）；免去孙旭培所长职务、徐耀魁副所长职务。',
            '7 月，社科院党委决定增补喻权域为新闻所党委委员。',
            '8 月，社科院批复同意新闻所学术委员会由喻权域、孙旭培、徐耀魁、彭朝丞、陈崇山、陈力丹、明安香组成，喻权域为主任委员，孙旭培为副主任委员。',
            '12 月，新闻所聘任：阎焕书为编辑出版室主任；闵大洪为新闻学研究室副主任；时统宇为新闻事业研究室副主任；其他原任的各室主任、副主任不变。'
          ]
        },
        {
          year: '一九九五年',
          events: [
            '2 月，社科院批复新闻所第二届专业职务评委会由喻权域、孙旭培、陈崇山、彭朝丞、陈力丹、徐耀魁、明安香、宁新、闵大洪、时统宇、陈筠泉、靳辉明、商恺、方汉奇、赵玉明组成。主任喻权域，副主任孙旭培。'
          ]
        },
        {
          year: '一九九六年',
          events: [
            '2 月，社科院党委任命陈谈强为新闻所党委书记，免去张秉意党委书记职务。',
            '2 月，社科院任命陈谈强为新闻所副所长，免去张秉意新闻所副所长职务。',
            '8 月，新闻所聘任孙五三为编辑出版室副主任。',
            '10 月，社科院批复同意新闻所聘任梁博祥为编辑出版室副主任。',
            '10 月，社科院党委批复同意增补李斯颐为新闻所党委委员。',
            '10 月，社科院人事教育局批复，同意新闻所设一名所长助理，由李斯颐担任（正处级）。',
            '12 月，社科院批复同意新闻所第三届专业技术职务评委会由喻权域、孙旭培、陈力丹、明安香、徐耀魁、宁新、闵大洪、时统宇、赵玉明、陈谈强、李斯颐、孙五三、徐人仲、宋小卫、成美组成。主任喻权域，副主任陈谈强。'
          ]
        },
        {
          year: '一九九七年',
          events: [
            '1 月，社科院任命宁新为新闻研究所副所长。',
            '3 月，社科院科研局批复同意成立“中国社会科学院新闻研究所新闻与传播法制研究中心”，不设人员编制，经费自筹；同意成立“中国社会科学院传播与青少年发展研究中心”，不设人员编制，经费自筹。',
            '3 月，新闻所党委向院人事教育局备案，任命蒋勇为所办公室副主任。',
            '4 月，社科院人事教育局文件通知，同意任命马桂芝为新闻所办公室主任，邹本浩为办公室正处级调研员。',
            '4 月，新闻所党委向院人事教育局上报了免去阎焕书编辑出版室主任，由喻权域兼主任的备案报告。',
            '9 月，社科院文件通知，根据中编办（97）54 号文件精神，同意“中国社会科学院新闻研究所”更名为“中国社会科学院新闻与传播研究所”。',
            '10 月，社科院党委任命尹韵公为新闻与传播研究所党委副书记。社科院任命尹韵公为新闻与传播研究所副所长。'
          ]
        },
        {
          year: '一九九八年',
          events: [
            '9 月，社科院任命尹韵公为新闻与传播研究所所长，宁新、李斯颐为副所长；免去喻权域所长职务、陈谈强副所长职务。',
            '9 月，社科院党委任命李斯颐为新闻与传播研究所党委副书记；免去陈谈强的党委书记职务、尹韵公的党委副书记职务。',
            '11 月，社科院党组免去陈谈强、喻权域的新闻所党委委员职务。'
          ]
        },
        {
          year: '一九九九年',
          events: [
            '1 月，社科院科研局文件批复，决定《真理的追求》由新闻与传播研究所主办，喻权域担任主编，陈谈强担任执行主编。',
            '4 月，人事局三处电话通知，同意成立网络与数字化传媒研究室。',
            '6 月，社科院文件批复同意新闻所学术委员会由尹韵公、陈力丹、孙旭培、明安香、李斯颐、闵大洪、卜卫组成。尹韵公为主任委员，陈力丹为副主任委员。',
            '11 月，社科院批复，同意新闻与传播所研究系列第四届中级专业技术职务评审委员会由尹韵公、喻权域、陈力丹、孙旭培、明安香、谢宏、李年贵、张涛、程曼丽组成。'
          ]
        },
        {
          year: '二零零零年',
          events: [
            '1 月，社科院文件批复同意新闻所党委换届选举结果，新一届党委由尹韵公、宁新、孙旭培、闵大洪、马桂芝组成。批准尹韵公为党委书记。',
            '2 月，新闻所党委上报了向院人事教育局并院党组办的请示，同意李斯颐辞去副所长职务。',
            '7 月，社科院党组通知决定任命孟庆海为新闻所党委书记；免去李斯颐的党委副书记职务。',
            '7 月，社科院文件通知任命孟庆海为新闻所副所长；免去宁新、李斯颐的副所长职务。',
            '7 月，社科院党组通知决定：免去尹韵公新闻所党委书记职务。',
            '9 月，新闻与传播所党委决定：聘任闵大洪为网络与数字化传媒研究室主任，免去其新闻学研究室副主任职务；聘任阎焕书为编辑出版室主任；免去孙五三编辑出版室副主任职务。',
            '12 月，社科院人事教育局通知，同意张西明任新闻所所长助理。',
            '12 月，新闻所党委决定：聘任时统宇为新闻事业研究室主任，唐绪军为新闻事业研究室副主任。'
          ]
        },
        {
          year: '二零零一年',
          events: [
            '8 月，社科院党组批复，同意孙旭培不再担任新闻所党委委员职务，并同意补选一位党委委员。',
            '9 月，社科院党组批复，同意补选张西明为新闻所党委委员。',
            '10 月，新闻与传播研究所的职能处室和研究（业务）室为：办公室、马克思主义新闻学研究室、传播学研究室、新闻事业研究室、网络与数字化传媒研究室、编辑出版室、图书资料室。'
          ]
        },
        {
          year: '二零零二年',
          events: [
            '3 月，经院人事局同意，新闻与传播研究所党委聘任王辉为图书资料室副主任。',
            '10 月，社科院人事局下达新闻与传播所编制数额为 50 个，经费实行全额拨款。',
            '10 月，社科院批复同意新闻与传播研究所研究系列副高级第五届专业技术资格评审委员会由尹韵公、陈力丹、明安香、张西明、方小翔、郑保卫、崔保国、陈卫星、涂光晋组成。'
          ]
        },
        {
          year: '二零零三年',
          events: [
            '9 月，社科院院务会决定，任命张西明为新闻与传播研究所副所长。',
            '6 月，鉴于马克思主义新闻学研究室主任陈力丹调离新闻所。经院人事局同意，新闻与传播研究所党委聘任宋小卫为马克思主义新闻学研究室主任。'
          ]
        },
        {
          year: '二零零四年',
          events: [
            '1 月，研究生院同意任命张西明为新闻系主任。',
            '5 月，社科院科研局同意，成立中国传媒集团研究中心，主任尹韵公。',
            '11 月，社科院科研局批复，同意新闻与传播研究所学术委员会由尹韵公、张西明、明安香、卜卫、时统宇、宋小卫、唐绪军组成。'
          ]
        },
        {
          year: '二零零五年',
          events: [
            '8 月，社科院党组决定，任命张昌东为新闻与传播研究所党委书记、党委委员；免去孟庆海的新闻与传播研究所党委书记、党委委员职务。',
            '8 月，社科院院务会议决定，任命张昌东、唐绪军为新闻与传播研究所副所长；免去孟庆海的新闻与传播研究所副所长职务。',
            '9 月，社科院院务会议决定，免去张西明的新闻与传播研究所副所长职务。',
            '10 月，社科院批复同意，新闻与传播研究所研究系列副高级第六届专业技术资格评审委员会由尹韵公、明安香、时统宇、卜卫、郭庆光、徐泓、雷跃捷组成。',
            '12 月，研究生院同意任命唐绪军为新闻系主任兼任院教授委员会委员。'
          ]
        },
        {
          year: '二零零六年',
          events: [
            '6 月，鉴于传播学研究室主任明安香，编辑室主任阎焕书退休。所长办公会研究决定，由王怡红主持传播学研究室工作，钱莲生主持编辑室工作。'
          ]
        },
        {
          year: '二零零七年',
          events: [
            '3 月，社科院党组决定，任命庄前生为新闻与传播研究所党委书记；免去张昌东的新闻与传播研究所党委书记、党委委员职务。',
            '3 月，社科院院务会议决定，任命庄前生为新闻与传播研究所副所长；免去张昌东的新闻与传播研究所副所长职务。',
            '8 月，社科院党组同意增补唐绪军为新闻所党委委员。新闻所党委由庄前生、尹韵公、唐绪军组成，庄前生为党委书记。',
            '8 月，社科院直属机关纪委批复，同意任命唐绪军为新闻与传播研究所纪律检查组组长，黄双润、刘瑞生任组员。',
            '8 月，所党委研究决定，社科院直属机关党委同意，成立新闻所党委中心组，成员是庄前生、尹韵公、唐绪军，庄前生任组长，黄双润任秘书。',
            '9 月，所党委研究决定，社科院人事教育局同意，任命王萱为办公室副主任，蒋勇为正处级调研员，张正鹄为副处级调研员，王怡红为传播学研究室主任，姜飞为传播学研究室副主任，殷乐为中国新闻事业研究室副主任，孟威为网络与数字化传媒研究室副主任，钱莲生为编辑室主任。',
            '10 月，所党委会研究决定，社科院人事教育局审批，任命黄双润为新闻与传播研究所办公室副主任。'
          ]
        },
        {
          year: '二零零八年',
          events: [
            '1 月，经院科研局批准，季刊《新闻与传播研究》改为双月刊。',
            '11 月，社科院批复，同意新闻与传播研究所研究系列副高级第七届专业技术资格评审委员会由尹韵公、唐绪军、宋小卫、卜卫、时统宇、钱莲生、雷跃捷、郑保卫、崔保国组成。'
          ]
        },
        {
          year: '二零零九年',
          events: [
            '7 月，新闻与传播研究所部分迁入东城区先晓胡同 10 号，原新闻出版总署版本图书馆三层、四层。',
            '11 月，新闻与传播研究所党委研究决定，院人事教育局同意，聘任宋小卫为马克思主义新闻学研究室主任、姜飞为传播学研究室主任、殷乐为媒介研究室主任、杨瑞明为信息室主任、钱莲生为《中国新闻年鉴》编辑部主任、刘瑞生为《新闻与传播研究》编辑部主任。',
            '12 月，新闻与传播研究所党委研究决定，社科院人事教育局审批，任命黄双润为办公室主任。',
            '12 月，社科院科研局批复，新闻与传播研究所学术委员由 7 人组成：主任尹韵公，副主任唐绪军，成员庄前生、卜卫、宋小卫、时统宇、王怡红。'
          ]
        },
        {
          year: '二零一零年',
          events: [
            '3 月，经社科院人事教育局批准，新闻学研究室更名为马克思主义新闻学研究室。',
            '9 月，所党委会研究决定，社科院人事教育局同意，聘任孟威为网络学研究室主任。'
          ]
        },
        {
          year: '二零一二年',
          events: [
            '2 月，社科院人事教育局批复，新闻与传播研究所第八届副高级专业技术资格评审委员会由唐绪军、宋小卫、卜卫、时统宇、钱莲生、王怡红、郭镇之、胡智锋、彭兰组成。',
            '2 月，社科院党组会议决定，任命赵天晓为新闻与传播研究所党委副书记；免去庄前生的新闻与传播研究所党委书记职务。',
            '2 月，社科院院务会议决定，任命赵天晓为新闻与传播研究所副所长；免去尹韵公的新闻与传播研究所所长职务、庄前生的副所长职务。',
            '6 月，院直属机关党委批准同意增补黄双润为新闻所党委委员。新闻所党委由赵天晓、唐绪军、黄双润组成。',
            '6 月，社科院科研局批复，同意增补刘晓红、姜飞为新闻与传播研究所学术委员。',
            '7 月，所党委研究决定，社科院直属机关党委同意，新闻所党委中心组进行人员调整，成员是赵天晓、唐绪军、黄双润，赵天晓任组长，贾云海任秘书。',
            '9 月，人力资源和社会保障部、全国博士后管委会批准，增设新闻与传播研究所为新闻传播学博士后科研流动站。',
            '11 月，社科院人事教育局批复，同意《中国新闻年鉴》编辑部和《新闻与传播研究》编辑部合并组建为编辑室。聘任钱莲生为编辑室主任。',
            '11 月，北京市新闻出版局批复同意，《新闻与传播研究》杂志自 2013 年 1 月起由双月刊变更为月刊。'
          ]
        },
        {
          year: '二零一三年',
          events: [
            '6 月，社科院党组会议决定，任命赵天晓为新闻与传播研究所党委书记。',
            '6 月，社科院院务会议决定，任命唐绪军为新闻与传播研究所所长。'
          ]
        },
        {
          year: '二零一四年',
          events: [
            '4 月，社科院人事教育局批复，新闻与传播研究所第九届副高级专业技术资格评审委员会由唐绪军、宋小卫、卜卫、时统宇、钱莲生、王怡红、姜飞、渠敬东、段鹏组成。',
            '7 月，所党委会研究决定，社科院人事教育局批复，同意王海峰任新闻与传播研究所所长助理。',
            '11 月，所党委会研究决定，社科院人事教育局同意：聘任黄楚新为马克思主义新闻学研究室主任、向芬为副主任；聘任张丹为传播学研究室副主任；聘任冷凇为媒介研究室副主任；聘任张化冰为网络学研究室副主任；聘任杨斌艳为信息室副主任；聘任朱鸿军为编辑室副主任。'
          ]
        },
        {
          year: '二零一五年',
          events: [
            '3 月，社科院科研局批复，新闻与传播研究所学术委员由 9 人组成：主任唐绪军，副主任宋小卫，成员卜卫、刘晓红、时统宇、王怡红、陈卫星、姜飞、崔保国。'
          ]
        },
        {
          year: '二零一六年',
          events: [
            '2 月，所党委会研究决定，社科院人事局批准同意，任命贾云海为办公室副主任。',
            '2 月，新闻与传播研究所迁入朝阳区潘家园东里 9 号，国家方志馆二层。',
            '7 月，社科院党组决定，任命季为民为新闻与传播研究所纪委书记、副所长。',
            '9 月，所党委会研究决定，社科院人事局批准同意，任命吴秋玲为办公室副主任。',
            '12 月，社科院党组批复同意，新一届新闻所党委由赵天晓、唐绪军、季为民、黄双润、钱莲生组成，赵天晓任党委书记。成立新闻所纪委，由季为民、贾云海、殷乐组成，季为民任纪委书记。'
          ]
        },
        {
          year: '二零一七年',
          events: [
            '3 月，王海峰调任院直属机关纪委副书记，不再担任新闻所所长助理。',
            '4 月，社科院人事教育局批复，新闻与传播研究所第十届副高级专业技术资格评审委员会由唐绪军、宋小卫、钱莲生、姜飞、孟威、殷乐、渠敬东、段鹏、史安斌组成。'
          ]
        },
        {
          year: '二零一八年',
          events: [
            '3 月，社科院科研局批复，同意增补季为民、黄楚新、殷乐为新闻与传播研究所学术委员会委员；同意王怡红、时统宇、姜飞不再担任所学术委员会委员。调整后的新闻与传播研究所学术委员会成员是：唐绪军、宋小卫、卜卫、刘晓红、季为民、黄楚新、殷乐、崔保国、陈卫星。'
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.history-panel {
  background: #fff;
  border: 1px solid #ece7dd;
}

.history-title {
  background: #ce6a33;
  color: #fff;
  font-size: 24px;
  line-height: 34px;
  padding: 12px 24px;
  font-family: SourceHanSerifCN-SemiBold, 'PingFang SC', sans-serif;
}

.history-meta {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px 0;
  color: #a45f19;
  font-size: 14px;
  line-height: 1.7;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
}

.history-section {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: 16px;
  padding: 18px 24px;
  border-top: 1px solid rgba(190, 138, 74, 0.16);
}

.history-year {
  color: #a45f19;
  font-size: 18px;
  line-height: 1.7;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
  font-weight: 700;
}

.history-body {
  color: #1c1c1c;
  font-size: 16px;
  line-height: 1.9;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
}

.history-body p {
  margin: 0 0 8px;
}

.history-body p:last-child {
  margin-bottom: 0;
}

.history-note {
  margin: 6px 24px 24px;
  color: #7d6d57;
  font-size: 14px;
  line-height: 1.7;
  text-align: right;
  font-family: SourceHanSerifCN-Regular, 'PingFang SC', sans-serif;
}

@media (max-width: 960px) {
  .history-section {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .history-title {
    font-size: 22px;
    line-height: 32px;
  }

  .history-year {
    font-size: 17px;
  }
}
</style>
